import { useMemo } from 'react';
import type { ethers } from 'ethers';
import { useWallet } from './useWallet';
import { getReadProvider } from '../lib/contracts';

/**
 * Returns the best available provider:
 *   1. The connected wallet's BrowserProvider (chain-aware, gets reorgs)
 *   2. A read-only provider (VITE_SEPOLIA_RPC or public fallback)
 *
 * The provider instance is stable while wallet status is stable, so
 * downstream useQuery keys are stable too.
 */
export function useReadProvider(): ethers.Provider {
  const wallet = useWallet();
  return useMemo(() => {
    if (wallet.status === 'connected') return wallet.provider;
    return getReadProvider();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [wallet.status]);
}
